import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectSkinById, setEditId } from "../../../store/mine_craft/skinsSlice";
import { destroySkin, fetchSkin } from "../../../actions/mine_craft/skinsActions";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import {
  LikeOutlined,
  MessageOutlined,
  StarOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import EditCategory from "../categories/Edit";
import ReorderCategories from "../categories/Reorder";
import NewCategory from "../categories/New";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";
import { ButtonDestroy, ButtonDownload, ButtonEdit } from "../../../componets/Buttons";
import usePermissions from "../../../hooks/usePermissions";

const TARGET_ID = 1;

const Show: React.FC = () => {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const skin      = useAppSelector(state => id ? selectSkinById(state, id) : undefined);
  const { write_minecraft } = usePermissions();

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchSkin(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (skin) {
      dispatch(setEditId(skin.id));
    }
  }

  function onClickDestroy() {
    if (skin) {
      handleDestroy(skin.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroySkin(id));

    if (destroySkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(minecraftUrls.skinsPath()), 1000);
    }

    if (destroySkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-skins-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            skin &&
              <SummaryShow
                title={skin.title}
                image={skin.thumbnail_url}
                createdAt={skin.created_at}
                updatedAt={skin.updated_at}
                className='v-mb-15'
                actions={[
                  ...(skin.saven_image_url ? [<ButtonDownload key='button-download' href={skin.saven_image_url} />] : []),
                  ...(write_minecraft ? [
                    <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                    <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                  ] : [])
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={StarOutlined} text={skin?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={skin?.likes_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={skin?.downloads_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={skin?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details skin={skin} /> },
            { label: 'Comments', key: 'comment', children: <Comments skinId={skin?.id} /> }
          ]}
        />
      </div>

      <SidebarShow skin={skin} />

      <Edit />

      <NewCategory />
      <EditCategory />
      <ReorderCategories />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
